<div class="bloco" [formGroup]="form">
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>CST IBS/CBS</mat-label>
        <mat-select formControlName="codigoCst" (selectionChange)="onCstSelecionado()">
          <mat-option [value]="null">Selecione</mat-option>
          @for (c of listaCstIbsCbs; track c.codigo) {
            <mat-option [value]="c.codigo">{{ c.codigo }} - {{ c.descricao }}</mat-option>
          }
        </mat-select>
        @if (listaCstIbsCbs.length === 0) {
          <mat-hint>Lista indisponível - verifique o aviso acima</mat-hint>
        }
      </mat-form-field>
    </div>

    <div class="col-12 col-md-6">
      <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
        <mat-label>cClassTrib</mat-label>
        <mat-select formControlName="codigoClassificacaoTributaria">
          <mat-option [value]="null">Selecione</mat-option>
          @for (c of cclasstribsFiltrados; track c.codigo) {
            <mat-option [value]="c.codigo">{{ c.codigo }} - {{ c.descricao }}</mat-option>
          }
        </mat-select>
        @if (listaCclasstribIbsCbs.length === 0) {
          <mat-hint>Lista indisponível - verifique o aviso acima</mat-hint>
        }
      </mat-form-field>
    </div>

    @if (!form.get('codigoCst')?.value) {
      <div class="col-12">
        <app-empty-state icon="percent" title="Selecione o CST"
          subtitle="Os campos e os valores apurados aparecem conforme o código informado."></app-empty-state>
      </div>
    }

    @if (cstSelecionado && cclasstribSelecionado) {
      <div class="col-12">
        <div class="regra-aplicada-card">
          <mat-icon class="material-symbols-outlined">gavel</mat-icon>
          <div>
            <strong>CST {{ cstSelecionado.codigo }} · cClassTrib {{ cclasstribSelecionado.codigo }} - {{ cclasstribSelecionado.descricao }}</strong>
            <p>{{ cstSelecionado.descricao }}</p>
            <span class="status-badge" [class.badge-verde]="gerarIbsCbs" [class.badge-cinza]="!gerarIbsCbs">
              {{ gerarIbsCbs ? 'Gera IBS/CBS' : 'Não gera IBS/CBS' }}
            </span>
          </div>
        </div>
      </div>
    }

    @if (!gerarIbsCbs && form.get('codigoCst')?.value) {
      <div class="col-12">
        <app-alert-card type="warning" title="Classificação sem débito de IBS/CBS">
          A classificação selecionada não gera débito de IBS/CBS para este item.
        </app-alert-card>
      </div>
    }

    @if (gerarIbsCbs) {
      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>percent</mat-icon>
            <span>CBS</span>
          </div>
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota CBS (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaCbs" class="campo-numero">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>account_balance</mat-icon>
            <span>IBS UF</span>
          </div>
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota IBS UF (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaIbsUf" class="campo-numero">
              </mat-form-field>
            </div>
            @if (indicadores.ibsCbs.ibsUf.diferimento) {
              <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Diferimento IBS UF (%)</mat-label>
                  <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualDiferimentoIbsUf" class="campo-numero">
                </mat-form-field>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>location_city</mat-icon>
            <span>IBS Municipal</span>
          </div>
          <p class="sub-section-sub-title">A competência municipal do IBS vigora a partir de 01/01/2027 - até lá a alíquota permanece 0,00%.</p>
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Alíquota IBS Municipal (%)</mat-label>
                <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="percentualAliquotaIbsMunicipal" class="campo-numero">
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="sub-section-container">
          <div class="sub-section-title">
            <mat-icon>calculate</mat-icon>
            <span>Valores apurados</span>
          </div>
          @if (isRecalculoPendente || form.get('valorBaseCalculo')?.value == null) {
            <app-empty-state icon="calculate" title="Nenhum valor apurado"></app-empty-state>
          } @else {
            <div class="row g-3">
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Base</mat-label>
                  <input matInput type="text" [value]="form.get('valorBaseCalculo')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Valor CBS</mat-label>
                  <input matInput type="text" [value]="form.get('valorCbs')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Valor IBS UF</mat-label>
                  <input matInput type="text" [value]="form.get('valorIbsUf')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Valor IBS Municipal</mat-label>
                  <input matInput type="text" [value]="form.get('valorIbsMunicipal')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              <div class="col-6 col-md-3">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>Valor IBS total</mat-label>
                  <input matInput type="text" [value]="form.get('valorIbs')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                </mat-form-field>
              </div>
              @if (form.get('percentualDiferimentoIbsUf')?.value) {
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Diferido IBS UF</mat-label>
                    <input matInput type="text" [value]="form.get('valorDiferimentoIbsUf')?.value || 0 | abnt: 'preco': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
              }
              @for (aliquota of aliquotasApuradas; track aliquota.rotulo) {
                <div class="col-6 col-md-3">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>{{ aliquota.rotulo }} (%)</mat-label>
                    <input matInput type="text" [value]="aliquota.valor | abnt: 'quantidade': 2" [disabled]="true" class="campo-numero">
                  </mat-form-field>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
